import { connect } from 'react-redux'
import React, { Component, PropTypes } from 'react'
import UpdatePasswordForm from 'client/features/session/components/UpdatePasswordForm.jsx'
import { SetPasswordRequest } from 'client/features/session/actions'
import FontAwesome from 'react-fontawesome'

class SetPassword extends Component {
    constructor() {
        super()
        this.submit = this.submit.bind(this)
    }

    submit(payload, dispatch) {
        dispatch(SetPasswordRequest.post.action({ payload: { ...payload, token: this.props.params.token } }))
    }

    render() {
        return (
            <div>
                <div className='text-center'>
                    <h4 className='text-uppercase font-bold m-b-0'>Modification de mot de passe</h4>
                </div>
                <div className='panel-body'>
                    {
                        this.props.session.setPasswordProgress ?
                            <FontAwesome name='cog' spin />
                        :
                            this.props.session.setPasswordSubmited ?
                                <p>Vous pouvez maintenant utiliser ce nouveau mot de passe dans l'application mobile Beeoapp.</p>
                            :
                                <UpdatePasswordForm onSubmit={ this.submit }/>
                    }
                    {
                        this.props.session.setPasswordFailure ?
                            <p className='error'>Ce lien n'est plus valide, merci de recommencer la demande.</p>
                        : null 
                    }
                </div>
            </div>
        )
    }
}

SetPassword.contextTypes = {
    router: PropTypes.object.isRequired,
    store: PropTypes.object.isRequired,
    session: PropTypes.object
}

const mapStateToProps = (state) => {
    const { session } = state
    return {
        session
    }
}

export default connect(mapStateToProps)(SetPassword)


// WEBPACK FOOTER //
// ./src/client/features/session/containers/NewPassword.jsx